import { Pipe, PipeTransform } from '@angular/core';
import { trimLeadingSlash, trimTrailingSlash } from '@panaya/utils';
import { injectWidgetConfigProp } from '@panaya/ai-chat/utils';

@Pipe({
    standalone: true,
    name: 'widgetResourceUrl'
})
export class WidgetResourceUrlPipe implements PipeTransform {
    private readonly widgetLoaderUrl = trimTrailingSlash(injectWidgetConfigProp('appUrl'));

    public transform(value: string): string {
        return `${this.widgetLoaderUrl}/${trimLeadingSlash(value)}`;
    }
}
